import React from 'react'

export const AnalysisRequestScheduleReportsButton = ({ setShowModal, text, disabled = false }) => {
    return (
        <button className='btn btn-info d-flex align-items-center py-1 rounded-3 mx-1' disabled={disabled} onClick={() => setShowModal(true)} >
            <span className="mdi mdi-18px mdi-calendar-multiple text-light me-2"></span>{text}
        </button>
    )
}
